module.exports = __webpack_public_path__ + "img/ipld.b584fd8b.svg";